import { render } from "./MyCollection.vue?vue&type=template&id=5b66e5f1&scoped=true&ts=true"
import script from "./MyCollection.vue?vue&type=script&lang=ts"
export * from "./MyCollection.vue?vue&type=script&lang=ts"

import "./MyCollection.vue?vue&type=style&index=0&id=5b66e5f1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b66e5f1"]])

export default __exports__